import {Component, Input} from '@angular/core';

@Component({
  selector: 'si-mtest-medical-test-image-icon',
  templateUrl: './mtest-medical-test-image-icon.component.html',
  styleUrls: ['./mtest-medical-test-image-icon.component.scss']
})
export class MtestMedicalTestImageIconComponent {
  @Input() styleClass: string;
  @Input() requestTypeId: number;
  @Input() requestStateId: number;

  onClickMedicalImageMock(): void {
    const url = 'assets/images/resonancia_magnética_cardiaca2.jpg';
    window.open(url, '_blank');
  }

  onClickMedicalReportMock(): void {
    const url = 'assets/images/CardioRM.pdf';
    window.open(url, '_blank');
  }
}
